import styled from "styled-components";

export const Container = styled.div`
  margin-top: 8rem;
  margin-bottom: 5rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 1000px) {
    margin-top: 1rem;
  }
`;


export const TextBlock = styled.div`
  position: relative;
  width: 45%;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;
export const TitleBlock = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 3rem;
  @media(max-width: 1000px){
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const Hours = styled.h1`
  margin: 0;
  text-align: left;
  padding: 0;
  width: 100%;
  @media (max-width: 1000px) {
    text-align: center;
  }
`;

export const Location = styled.h1`
  margin: 0 0 0 2rem;
  white-space: nowrap;
  @media (max-width: 1000px) {
    text-align: center;
    margin: 0;
    white-space: normal;
    line-height: 4rem;
  }
`;

export const Days = styled.p`
  font-size: 23px;
  @media (max-width: 1000px) {
    font-size: 18px;
  }
`;

export const Image = styled.div`
  width: 45%;
  > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const Small = styled.p`
    font-size: 15px;
    text-align: center;
`
